import request from '@/utils/request'

/**
 * 统一查询API - AI财务数据指挥中心
 */
export const unifiedQueryApi = {
  /**
   * 获取统计信息
   */
  getStatistics() {
    return request({
      url: '/unified-query/statistics',
      method: 'get'
    })
  },

  /**
   * 统一查询所有类型实体
   */
  queryAllEntities(data) {
    return request({
      url: '/unified-query/all-entities',
      method: 'post',
      data
    })
  },

  /**
   * 获取关系图谱数据
   */
  getRelationshipGraph(data) {
    return request({
      url: '/unified-query/relationship-graph',
      method: 'post',
      data
    })
  },

  /**
   * 获取AI处理历史
   */
  getAiProcessHistory(entityType, entityId) {
    return request({
      url: `/unified-query/ai-history/${entityType}/${entityId}`,
      method: 'get'
    })
  },

  /**
   * 票据统一查询
   */
  queryDocuments(data) {
    return request({
      url: '/unified-query/documents',
      method: 'post',
      data
    })
  },

  /**
   * 银证统一查询
   */
  queryReceipts(data) {
    return request({
      url: '/unified-query/receipts',
      method: 'post',
      data
    })
  },

  /**
   * 跨类型关联查询
   */
  queryCrossTypeRelations(data) {
    return request({
      url: '/unified-query/relations',
      method: 'post',
      data
    })
  }
}

/**
 * 批量操作API
 */
export const batchOperationApi = {
  /**
   * 批量AI关联
   */
  batchAiRelation(data) {
    return request({
      url: '/ai-relation/batch-analyze',
      method: 'post',
      data
    })
  },

  /**
   * 批量AI归并
   */
  batchAiMerge(data) {
    return request({
      url: '/ai-merge/batch-analyze',
      method: 'post',
      data
    })
  },

  /**
   * 批量生成凭证
   */
  batchGenerateVoucher(data) {
    return request({
      url: '/ai-accounting/batch-generate-voucher',
      method: 'post',
      data
    })
  }
}

/**
 * 实体详情API
 */
export const entityDetailApi = {
  /**
   * 获取票据详情
   */
  getDocumentDetail(id) {
    return request({
      url: `/bill/${id}`,
      method: 'get'
    })
  },

  /**
   * 获取银证详情
   */
  getReceiptDetail(id) {
    return request({
      url: `/bank-receipts/${id}`,
      method: 'get'
    })
  },

  /**
   * 获取归并组详情
   */
  getGroupDetail(groupId, type) {
    const url = type === 'DOCUMENT_GROUP'
      ? `/merge-groups/documents/${groupId}`
      : `/merge-groups/receipts/${groupId}`

    return request({
      url,
      method: 'get'
    })
  },

  /**
   * 获取凭证详情
   */
  getVoucherDetail(id) {
    return request({
      url: `/voucher/${id}`,
      method: 'get'
    })
  }
}

/**
 * 手动操作API
 */
export const manualOperationApi = {
  /**
   * 手动创建关联关系
   */
  createManualRelation(data) {
    return request({
      url: '/relations',
      method: 'post',
      data
    })
  },

  /**
   * 手动票据归并
   */
  manualDocumentMerge(documentIds, groupName) {
    return request({
      url: '/merge-engine/documents/manual-merge',
      method: 'post',
      data: {
        documentIds,
        groupName
      }
    })
  },

  /**
   * 手动银证归并
   */
  manualReceiptMerge(receiptIds, groupName) {
    return request({
      url: '/merge-engine/receipts/manual-merge',
      method: 'post',
      data: {
        receiptIds,
        groupName
      }
    })
  },

  /**
   * 解散归并组
   */
  dissolveGroup(groupId, type) {
    const url = type === 'DOCUMENT_GROUP'
      ? `/merge-engine/documents/groups/${groupId}`
      : `/merge-engine/receipts/groups/${groupId}`

    return request({
      url,
      method: 'delete'
    })
  },

  /**
   * 删除关联关系
   */
  deleteRelation(relationId) {
    return request({
      url: `/relations/${relationId}`,
      method: 'delete'
    })
  }
}

/**
 * 导出API
 */
export const exportApi = {
  /**
   * 导出查询结果
   */
  exportQueryResults(data) {
    return request({
      url: '/unified-query/export',
      method: 'post',
      data,
      responseType: 'blob'
    })
  },

  /**
   * 导出统计报表
   */
  exportStatisticsReport() {
    return request({
      url: '/unified-query/export-statistics',
      method: 'get',
      responseType: 'blob'
    })
  },

  /**
   * 导出关系图谱
   */
  exportRelationshipGraph(data) {
    return request({
      url: '/unified-query/export-graph',
      method: 'post',
      data,
      responseType: 'blob'
    })
  }
}

// 默认导出主要API
export default {
  ...unifiedQueryApi,
  batch: batchOperationApi,
  detail: entityDetailApi,
  manual: manualOperationApi,
  export: exportApi
}
